import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

const ProductGroup = ({title, description, children}) => (
    <div className={styles.container}>
        <h2 className={styles.title}>
            {title}
            {description && <span className={styles.description} data-desc={description}>?</span>}
        </h2>
        <div className={styles.group}>
            {children}
        </div>
    </div>
);

ProductGroup.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default ProductGroup;
